﻿import {AccessToken} from "./types";
import {useMateApi} from "./useMateApi";

export const useInventoryApi = (accessToken: AccessToken) => {

    const {jsonEndpoint} = useMateApi(accessToken);
    const api = jsonEndpoint("/api/inventory");

    const finish = (oid: number) => api.get({oid}, {url: `/finish`});
    const recount = (oid: number) => api.get({oid}, {url: `/recount`});
    const reopen = (oid: number) => api.get({oid}, {url: `/reopen`});

    const getDownloadCsvUrl = (oid: number, name?: string) =>
        `/api/inventory/download-shelf-overview/${name}?oid=${oid}`;

    return {
        finish,
        recount,
        reopen,
        getDownloadCsvUrl
    }
}
